import React from 'react';

const GroupJoin: React.FC = () => {
  return (
    <div>
      {/* Group joining interface will go here */}
    </div>
  );
};

export default GroupJoin; 